import type { Theme } from "@mui/material"
import { GlobalNavigationItemTheme } from "core/themes/src/definitions/components.types"

export const createGlobalNavigationItemTheme = (theme: Theme): GlobalNavigationItemTheme => ({
    defaultProps: {},
    styleOverrides: {
        root: {
            "&.global-navigation-flat.active": {
                background: "#E51636",
            },
            "&.user-settings.global-navigation-flat.active": {
                background: "#E51636",
            },
            "&.active": {
                background: "#E51636",
            },
        },
    },
})
